<template>
    <div class="container">
        <h2>联系我们</h2>
        <div class="bar"></div>
        <div class="wrapper">
            <div class="item"
                 @click="show=true">
                <img src="https://oss.cloud.custouch.com/res/35726/服务热线@3x.png"
                     alt="">
                <p>服务热线</p>
            </div>
            <a class="item"
               href="https://webchat.7moor.com/wapchat.html?accessId=33c94e80-c8ec-11eb-9d18-d7e532a7d40e&fromUrl=&urlTitle=&language=ZHCN">
                <img src="https://oss.cloud.custouch.com/res/35727/在线客服@3x.png"
                     alt="https://www.moseeker.com/team/index/cid/14/tid/21516">
                <p>在线客服</p>

            </a>
            <a class="item"
               :href="form">
                <img src="https://oss.cloud.custouch.com/res/35724/留言咨询@3x.png"
                     alt="">
                <p>留言咨询</p>
            </a>
        </div>
        <van-popup v-model="show">
            <div class="service-wrapper">
                <p>圣戈班客服服务热线</p>
                <div class="phone-call">
                    <a href="tel:400 888 0198">400 888 0198</a>
                    <img @click="copy"
                         src="https://oss.cloud.custouch.com/res/35730/icon-copy@3x.png">
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script >
import copy from 'copy-to-clipboard'
export default {
    data() {
        return {
            show: false
        }
    },
    created() {
        this.$root.$emit('action', { name: this.$route.name })
    },
    methods: {
        copy() {
            copy('400 888 0198')
            this.$message('复制成功')
        }
    },
    computed: {
        form() {
            return window.env.VUE_APP_QUESTION_FORM +
                `?redirect=${encodeURIComponent(
                    window.location.href
                )}`
        }
    }
}
</script>
<style scoped lang="less">
.van-popup {
    border-radius: 0.5rem;
}
.service-wrapper {
    padding: 1.3rem 2rem;
    text-align: center;
    width: 13rem;
    color: #222;
    .phone-call {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 0.4rem;
        color: rgba(7, 68, 138, 1);
        > img {
            margin-left: 0.5rem;
            width: 0.9rem;
            object-fit: contain;
        }
    }
}
.container {
    padding: 1rem;
    padding-top: 0;
    color: rgba(7, 68, 138, 1);
    font-size: 0.9rem;
    .wrapper {
        position: relative;
        left: 1rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        margin-top: 2rem;
    }
    .item {
        width: 10rem;
        height: 4rem;
        display: flex;
        margin-bottom: 2rem;
        background: rgba(33, 156, 220, 0.1);
        align-items: center;
        position: relative;
        justify-content: center;
        &:nth-child(1) {
            img {
                left: -1rem;
            }
        }
        &:nth-child(2) {
            img {
                left: -2.5rem;
            }
        }
        &:nth-child(3) {
            img {
                left: -2rem;
            }
        }
        img {
            position: absolute;
            height: 4rem;
            object-fit: contain;
        }
        p {
            margin-left: 1.4rem;
        }
    }
    .bar {
        width: 1.6rem;
        height: 0.25rem;
        background: #00448a;
        margin-bottom: 0.8rem;
    }
    h2 {
        font-size: 0.8rem;
        line-height: 1.1rem;
        margin-bottom: 0.5rem;
        color: #00448a;
    }
}
</style>
